import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FeesTariffsPageRoutingModule } from './fees-tariffs-routing.module';

import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { FeesTariffsPage } from './fees-tariffs.page';
import {UiCCardInfoModule} from "@wlp/ui-c-card-info";
import {UiCCardFeesTariffsModule} from "@wlp/ui-c-card-fees-tariffs";
import {InterceptService} from "../../../../../../core/intercept/intercept.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FeesTariffsPageRoutingModule,
    UiBsTranslateModule,
    UiCCardInfoModule,
    UiCCardFeesTariffsModule,
  ],
  declarations: [FeesTariffsPage],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
})
export class FeesTariffsPageModule {}
